import React, { useState, useEffect } from "react";
// import Loading from "../Loader/Loading";
import "./Shift.css";
import { useNavigate } from "react-router-dom";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Shift = () => {
  const [shiftdetails, setshiftdetails] = useState([]);
  const [modifyshift, setmodifyshift] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const Navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(shiftdetails.length / itemsPerPage);

  const paginatedData = shiftdetails.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePageClick = (pageNum) => {
    setCurrentPage(pageNum);
  };

  const handlehomepage = () => {
    Navigate("/ad");
  };

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const handlemodifyshift = async () => {
    if (
      !modifyshift ||
      Object.keys(modifyshift).length === 0 ||
      Object.values(modifyshift).some((shift) => {
        if (!shift.type || !shift.date) return true;

        const selectedDate = new Date(shift.date);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize time to compare only dates
        return selectedDate < today;
      })
    ) {
      toast.error("Please select a valid future date and type for all users");
      return;
    }

    setIsLoading(true);

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/modifyshift.php`;
    const entries = Object.entries(modifyshift);

    for (const [userId, shift] of entries) {
      if (!shift.type || !shift.date) continue;

      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("assignedby_id", userDetails?.id);
      formData.append("new_shift", shift.type);
      formData.append("start_date", shift.date);

      const user = shiftdetails.find((u) => u.id.toString() === userId);

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();

        if (data.message) {
          toast.success(`User ${user?.user_name || userId}'s ${data.message}`);
          getshiftdetails();
        } else {
          toast.error(`User ${user?.user_name || userId}: Update failed`);
        }
      } catch (error) {
        toast.error(`User ${user?.user_name || userId}: Request error`);
      } finally {
        // setIsLoading(false); // hide loader
      }
    }
    setmodifyshift({});
  };

  const getshiftdetails = async () => {
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getshiftdetails.php`;
    const formData = new FormData();
    formData.append("role", userDetails?.role);

    try {
      const response = await fetch(apiUrl, { method: "POST", body: formData });
      const result = await response.json();
      if (result.message === "Records fetched successfully") {
        setshiftdetails(result.data);
      }
    } catch (error) {
      console.log("Error fetching tickets:", error);
    }
  };

  useEffect(() => {
    getshiftdetails();
  }, []);

  return (
    <>
      <div className="align">
        <button className="button" onClick={handlehomepage}>
          <svg className="svg">
            <FaLongArrowAltLeft />
          </svg>
          <div className="tet">Home</div>
        </button>
      </div>
      <div className="table-contain">
        <h2 className="shi">Shift Details</h2>
        <div className="table-scroll">
          <table className="shift-table">
            <thead>
              <tr>
                <th>SI No</th>
                <th>Employee Name</th>
                <th>Contact No</th>
                <th>Current Shift</th>
                <th>Upcoming Shift</th>
                <th>Assigned BY </th>
                <th>Modify Shift</th>
                <th>Start Date</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{item.emp_name}</td>
                  <td>{item.phone_no}</td>
                  <td>{item.current_shift}</td>
                  <td>
                    {" "}
                    {item.start_date === "0000-00-00"
                      ? " "
                      : `${item.new_shift} - ${item.start_date}`}
                  </td>
                  <td>{item.assign_name}</td>
                  <td>
                    <select
                      value={modifyshift[item.id]?.type || ""}
                      onChange={(e) =>
                        setmodifyshift((pv) => ({
                          ...pv,
                          [item.id]: {
                            ...(pv[item.id] || {}),
                            type: e.target.value,
                          },
                        }))
                      }
                    >
                      <option value="" disabled>
                        Select Shift
                      </option>
                      <option value={"General Shift - GS"}>
                        General Shift - GS
                      </option>
                      <option value={"First Shift - S1"}>
                        First Shift - S1
                      </option>
                      <option value={"Second Shift - S2"}>
                        Second Shift - S2
                      </option>
                      <option value={"Third Shift - S3"}>
                        Third Shift - S3
                      </option>
                    </select>
                  </td>
                  <td>
                    <input
                      className="stda"
                      type="date"
                      value={modifyshift[item.id]?.date || ""}
                      onChange={(e) =>
                        setmodifyshift((pv) => ({
                          ...pv,
                          [item.id]: {
                            ...(pv[item.id] || {}),
                            date: e.target.value,
                          },
                        }))
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {totalPages > 1 && (
        <div className="pagination-controls">
          <button onClick={handlePrev} disabled={currentPage === 1}>
            Prev
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={currentPage === i + 1 ? "active-page" : ""}
              onClick={() => handlePageClick(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button onClick={handleNext} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
      )}

      <div className="sbt">
        <button className="shbn" onClick={handlemodifyshift}>
          Submit
        </button>
      </div>
      {/* {isLoading && <Loading type="shift" />} */}
    </>
  );
};

export default Shift;
